import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { SeoLink } from 'dibs-seo/exports/SeoLink.tsx';
import { trackEvent } from 'dibs-tracking';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { type PdpSharedStorytellingShopAllLink_storyTellingTab$data } from './__generated__/PdpSharedStorytellingShopAllLink_storyTellingTab.graphql.ts';

type Props = {
    storyTellingTab: PdpSharedStorytellingShopAllLink_storyTellingTab$data;
};

const PdpSharedStorytellingShopAllLinkComponent: FC<Props> = ({ storyTellingTab }) => {
    const { browseLink, contentHeader, tabType } = storyTellingTab;
    return browseLink ? (
        <SeoLink
            linkData={browseLink}
            dataTn="pdp-storytelling-shop-all-link"
            target="_blank"
            onClick={() => {
                trackEvent({
                    category: 'product',
                    action: `shop all ${tabType} clicked`,
                    label: 'pdp',
                });
            }}
        >
            {tabType === 'iconic design' ? (
                <FormattedMessage
                    defaultMessage="Shop The {name}"
                    id="pdp.resp.storytelling.shopThe"
                    values={{ name: contentHeader }}
                />
            ) : (
                <FormattedMessage
                    defaultMessage="Shop All {name}"
                    id="pdp.resp.storytelling.shopAll"
                    values={{ name: contentHeader }}
                />
            )}
        </SeoLink>
    ) : null;
};

export const PdpSharedStorytellingShopAllLink = createFragmentContainer(
    PdpSharedStorytellingShopAllLinkComponent,
    {
        storyTellingTab: graphql`
            fragment PdpSharedStorytellingShopAllLink_storyTellingTab on StoryTellingTab {
                browseLink {
                    ...SeoLink_linkData
                }
                tabType
                contentHeader
                contentCreatorAttribution {
                    __typename
                }
            }
        `,
    }
);
